<template>
	<div>
		<v-snackbar
			v-model="snackbar"
			:timeout="10000"
			:top="true"
			color="accent"
			class="black--text"
		>
			{{ snackbarText }}
			<v-btn class="blexon-button" small icon @click="snackbar = false">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>
		<v-progress-linear v-show="dataLoading" color="accent" indeterminate></v-progress-linear>
		<v-container class="content" grid-list-md fluid>
			<v-layout row>
				<v-flex shrink>
					<h1>Fertigungen</h1>
				</v-flex>
				<v-flex>
					<v-btn @click="goToCapacity()">Auslastung</v-btn>
					<v-btn @click="goToManufacturingOverview()">Produktionsübersicht</v-btn>
				</v-flex>
			</v-layout>
			<div v-for="region in fertigers" v-bind:key="region.regionId">
				<hr style="margin-top: 2em" />
				<h2>{{ region.region }}</h2>
				<div
					style="
						display: grid;
						grid-gap: 10px;
						grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
					"
				>
					<div v-for="fertiger in region.fertigers" :key="fertiger.id">
						<v-card hover @click.native="goToFertiger(fertiger)">
							<v-card-title class="pb-0">
								<v-icon
									:color="getAdapterStateColor(fertiger.lastPoll)"
									style="padding-right: 0.2em"
									@click.stop="checkAdapter(fertiger)"
									:title="getLastPollFormatted(fertiger.lastPoll)"
								>
									offline_bolt
								</v-icon>
								<h2 style="color: #efbb20; margin: 0" class="font-weight-light">
									{{ fertiger.name }}
								</h2>
								<v-spacer></v-spacer>
								<v-menu offset-y v-model="fertiger.isOpen" close-on-click>
									<v-icon
										slot="activator"
										large
										color="primary"
										@click.stop="fertiger.isOpen = !fertiger.isOpen"
									>
										keyboard_arrow_down
									</v-icon>
									<v-list>
										<v-list-tile
											@click="executeRequest(fertiger)"
											title="Signalisiert dem Adapter jetzt sofort nach neuen Aufträgen zu fragen."
										>
											<v-list-tile-title>
												Abfrage jetzt ausführen
											</v-list-tile-title>
										</v-list-tile>
										<v-list-tile
											@click="updateAdapter(fertiger)"
											title="Signalisiert dem Adapter jetzt nach einer neuen Version zu suchen, diese herunterzuladen und zu installieren."
										>
											<v-list-tile-title> Update Adapter </v-list-tile-title>
										</v-list-tile>
										<v-list-tile
											@click="openConfig(fertiger)"
											title="Lädt die Konfigurationsdatei vom Server. Diese kann anschliessend bearbeitet und gespeichert werden."
										>
											<v-list-tile-title>
												Adapterkonfiguration
											</v-list-tile-title>
										</v-list-tile>
									</v-list>
								</v-menu>
							</v-card-title>
							<v-card-text style="min-height: 100px" class="pt-0">
								<img
									style="height: 60px; padding-top: 20px"
									onerror="this.style.display = 'none'"
									:src="getFertigerLogo(fertiger.id)"
								/>
							</v-card-text>
							<v-card-actions>
								<span style="font-size: 0.8em" class="ml-2"
									>Adapter Version: {{ fertiger.clientVersion }}</span
								>
								<v-spacer></v-spacer>
							</v-card-actions>
						</v-card>
					</div>
				</div>
			</div>
			<p v-if="fertigers.length <= 0" class="headline">
				<v-icon x-large color="accent">error_outline</v-icon>
				Zugriff nicht erlaubt.
			</p>
		</v-container>
		<v-dialog v-model="showConfig" width="700">
			<v-card>
				<v-card-text>
					<textarea v-model="config" style="width: 100%; height: 80vh"></textarea>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="showConfig = false">Schliessen</v-btn>
					<v-btn class="blexon-button" @click="saveConfig()"> Speichern </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
import httpClient from "../store/httpClient";
import moment from "moment";

export default {
	data() {
		return {
			snackbar: false,
			snackbarText: "",
			dataLoading: false,
			isLoading: false,
			showConfig: false,
			config: "",
			fertigerWithOpenConfig: null,
			isOpen: false,
		};
	},
	computed: {
		fertigers() {
			const regionByRegionId = (regionId) => {
				if (regionId === "1") {
					return "Schweiz";
				} else if (regionId === "2") {
					return "Deutschland";
				} else if (regionId === "3") {
					return "Österreich";
				}
			};
			var groupBy = function (xs, key) {
				return xs.reduce(function (rv, x) {
					(rv[x[key]] = rv[x[key]] || []).push(x);
					return rv;
				}, {});
			};
			const regions = groupBy(this.$store.state.fertiger, "regionId");
			var regionsWithFertigers = [];
			for (var prop in regions) {
				regionsWithFertigers.push({
					regionId: prop,
					region: regionByRegionId(prop),
					fertigers: regions[prop],
				});
			}
			return regionsWithFertigers;
		},
	},
	methods: {
		getLastPollFormatted(lastPoll) {
			return moment(lastPoll).format("[Letztes Signal am:] D. MMMM YYYY - HH:mm [Uhr]");
		},
		getAdapterStateColor(lastPoll) {
			if (moment().subtract(30, "minutes").isBefore(lastPoll)) {
				return "success";
			} else {
				return "error";
			}
		},

		goToFertiger(fertiger) {
			this.$router.push({ name: "order", params: { fertigerId: fertiger.id } });
		},

		goToCapacity() {
			this.$router.push({ name: "capacity" });
		},

		goToManufacturingOverview() {
			this.$router.push({ name: "manufacturingOverview" });
		},

		getFertigerLogo(id) {
			return `${process.env.VUE_APP_SERVER_URL}api/fertiger/getlogo?fertigerId=${id}`;
		},

		async updateAdapter(fertiger) {
			try {
				this.dataLoading = true;
				await httpClient().post(`api/Event/UpdateAdapter?fertigerId=${fertiger.id}`, null);
				this.setSnackbarText("Update erfolgreich eingeleitet.");
			} catch (err) {
				this.setSnackbarText(`Fehler beim Update.` + err);
			} finally {
				this.dataLoading = false;
			}
		},

		async openConfig(fertiger) {
			try {
				this.dataLoading = true;
				this.fertigerWithOpenConfig = fertiger;
				await httpClient().post(
					`api/Event/SaveConfigToServer?fertigerId=${fertiger.id}`,
					null
				);
				this.setSnackbarText("Config wird geladen...");
				await new Promise((r) => setTimeout(r, 2000));
				var configFile = await httpClient().get(
					`api/Fertiger/GetConfig?fertigerId=${fertiger.id}`
				);
				this.config = JSON.stringify(configFile.data, null, 2);
				this.showConfig = true;
			} catch (err) {
				this.setSnackbarText(`Fehler beim Laden des Configfiles.` + err);
			} finally {
				this.dataLoading = false;
			}
		},

		async saveConfig() {
			try {
				this.dataLoading = true;
				await httpClient().post(
					`api/Event/SendConfigToAdapter?fertigerId=${this.fertigerWithOpenConfig.id}`,
					{ Content: this.config }
				);
				this.setSnackbarText("Erfolgreich gespeichert.");
			} catch (err) {
				this.setSnackbarText(`Fehler beim Speichern der Konfigurationsdatei.` + err);
			} finally {
				this.dataLoading = false;
			}
		},

		async executeRequest(fertiger) {
			try {
				this.dataLoading = true;
				await httpClient().post(`api/Event/executeRequest?fertigerId=${fertiger.id}`, null);
				this.setSnackbarText("Signal erfolgreich.");
			} catch (err) {
				this.setSnackbarText(`Fehler bei der Signalisierung.` + err);
			} finally {
				this.dataLoading = false;
			}
		},

		async checkAdapter(fertiger) {
			try {
				this.dataLoading = true;
				await httpClient().post(`api/Event/CheckAdapter?fertigerId=${fertiger.id}`, null);
				this.setSnackbarText("Check erfolgreich.");
			} catch (err) {
				this.setSnackbarText(`Fehler beim Check.` + err);
			} finally {
				this.dataLoading = false;
			}
		},

		/**
		 * Sets the text in the snackbar and shows it.
		 */
		setSnackbarText(text) {
			this.snackbarText = text;
			this.snackbar = true;
		},
	},
};
</script>
